import Sentry from '@/services/sentry'
import UserAPI from '@/api/user'

const getters = {
  isSlideOptionAutocompleteEnabled: (_, __, rootState) => {
    return rootState.currentUser.userSetting.isSlideOptionAutocompleteEnabled
  },
  scimEnabled: (_, __, rootState, rootGetters) => {
    return rootState.currentUser.isScimEnabled && rootGetters['featureToggles/canUseSCIM']
  },
}
const actions = {
  setIsSlideOptionAutocompleteEnabledAction: async ({ commit }, isSlideOptionAutocompleteEnabled) => {
    try {
      UserAPI.setUserSetting({ isSlideOptionAutocompleteEnabled })
      commit('setUserSetting', {
        isSlideOptionAutocompleteEnabled,
      }, { root: true })
    } catch (e) {
      Sentry.captureException(e)
    }
  },
}

const userSettings = {
  namespaced: true,
  getters,
  actions,
}

export default userSettings
